/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Order_NoInputs */

const en_admin_payments_order_no = /** @type {(inputs: Admin_Payments_Order_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order No`)
};

const zh_admin_payments_order_no = /** @type {(inputs: Admin_Payments_Order_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订单号`)
};

/**
* | output |
* | --- |
* | "Order No" |
*
* @param {Admin_Payments_Order_NoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_order_no = /** @type {((inputs?: Admin_Payments_Order_NoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Order_NoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_order_no(inputs)
	return zh_admin_payments_order_no(inputs)
});
export { admin_payments_order_no as "admin.payments.order_no" }